import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { translateAndSortAscendant } from "../../../../common/helper";
import Select from "../../../../components/Select";

export default function Nationality({ searchObject, onChange, t }) {
  const [nationalities, setNationalities] = useState([]);

  useEffect(() => {
    CommonService.getAllNationalities().then((data) =>
      setNationalities(translateAndSortAscendant(data, "description"))
    );
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Nationality")}</legend>
      <Select
        name="nationalityId"
        onChange={onChange}
        value={searchObject.nationalityId || ""}
        className="form-select fontsize-legend"
      >
        <option value=""></option>
        {nationalities.map((nationality) => (
          <option
            className="fontsize-legend"
            key={nationality.id}
            value={nationality.id}
          >
            {t(nationality.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
